import { DisputeTypes } from "utils/constants";
import { FrontOfficeDisputes } from "./disputes";

export function FrontOfficeBankDisputes() {
  return <FrontOfficeDisputes disputeType={DisputeTypes.BankDisputes} />;
}
